var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_36917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5H9C8.72386 6.5 8.5 6.72386 8.5 7V13C8.5 13.2761 8.72386 13.5 9 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V7C13.5 6.72386 13.2761 6.5 13 6.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H9C8.72386 0.5 8.5 0.723858 8.5 1V3.01C8.5 3.28614 8.72386 3.51 9 3.51H13C13.2761 3.51 13.5 3.28614 13.5 3.01V1C13.5 0.723858 13.2761 0.5 13 0.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5H1C0.723858 0.5 0.5 0.723858 0.5 1V7C0.5 7.27614 0.723858 7.5 1 7.5H5C5.27614 7.5 5.5 7.27614 5.5 7V1C5.5 0.723858 5.27614 0.5 5 0.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.49H1C0.723858 10.49 0.5 10.7138 0.5 10.99V13C0.5 13.2761 0.723858 13.5 1 13.5H5C5.27614 13.5 5.5 13.2761 5.5 13V10.99C5.5 10.7138 5.27614 10.49 5 10.49Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_36917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.f0f1b21de0519f22c5e8350c222e6911.svg";
export { ForwardRef as ReactComponent };